import { render, staticRenderFns } from "./Gacha.vue?vue&type=template&id=6e952e6c&"
import script from "./Gacha.vue?vue&type=script&lang=ts&"
export * from "./Gacha.vue?vue&type=script&lang=ts&"
import style0 from "./Gacha.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports